import { setPrefetchProgress } from '@ts/core/actions/app';
import presetState from './presetState';
import parseLoadable from './parseLoadable';
import PrefetchObject from './PrefetchObject';

let timeout = 0;

function PushPrefetchedLocation(to = '/', dispatch) {
    const loadable = typeof window !== 'undefined' ? parseLoadable(to) : false;
    const prefetchObject = loadable ? PrefetchObject.create(to, loadable) : null;

    const setProgressHandlers = () => {
        dispatch(
            setPrefetchProgress({
                loading: true,
                ...prefetchObject.progress,
            })
        );
        prefetchObject.onProgress((self) =>
            dispatch(setPrefetchProgress({ loading: true, ...self.progress }))
        );
    };

    const cleanProgress = () => {
        dispatch(
            setPrefetchProgress({
                loading: false,
                ...prefetchObject.progress,
            })
        );

        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            dispatch(
                setPrefetchProgress({
                    loading: false,
                    total: 0,
                    loaded: 0,
                })
            );
        }, 300);
    };

    const redirect = () => {
        // preset state
        try {
            if (prefetchObject.isLoaded && prefetchObject.result) {
                presetState(dispatch)(prefetchObject);
            }
        } catch {}

        // change location
        window.browserHistory.push(to);
    };

    const prefetch = (redirectAfter) => {
        if (prefetchObject) {
            const f = () => {
                if (redirectAfter) {
                    redirect();
                    cleanProgress();
                }
            };

            if (prefetchObject.isLoaded) {
                // state is loaded
                f();
            } else {
                if (redirectAfter) {
                    setProgressHandlers();
                }

                // handle success loading
                prefetchObject.onLoad(() => f());

                if (!prefetchObject.isLoading) {
                    // handle failed fetch
                    prefetchObject.fetch().catch(() => f());
                }
            }
        }
    };

    if (prefetchObject) {
        PrefetchObject.cancelAllWithout(prefetchObject.key);
        prefetch(true);
    }
    if (!loadable) {
        redirect();
    }
}

export default PushPrefetchedLocation;
